import styled from 'styled-components';

export const FooterContainer = styled.div`
  margin-top: 15px;
  border-top: ${(props) => (props.isFromInterview ? '1px solid var(--dark)' : '')};
  background: ${({ isFromInterview, variant }) =>
    isFromInterview
      ? '#0d0d0d'
      : variant === 'partner-plus'
      ? 'var(--partnerLightBg)'
      : variant === 'regionals'
      ? 'var(--regionalsLightBg)'
      : variant === 'code-juniors'
      ? 'var(--juniorsLightBg)'
      : 'var(--siteSecondaryBgColor)'};
  transition: margin-bottom 0.3s ease;
  margin-bottom: ${(props) => props.isPricingBar && 'var(--topOfferSnackbarHeight)'};
  // @media (min-width: 481px) {
  //   margin-bottom: ${(props) => props.isPricingBar && '55px'};
  // }
  // @media (min-width: 576px) {
  //   margin-bottom: ${(props) => props.isPricingBar && '70px'};
  // }
  // @media (min-width: 768px) {
  //   margin-bottom: ${(props) => props.isPricingBar && '60px'};
  // }
`;

export const FooterBody = styled.div`
  width: var(--layoutWidth);
  max-width: var(--layoutMaxWidth);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  padding: 30px 20px;
  row-gap: 15px;
  column-gap: 10px;
  @media (min-width: 576px) {
    max-height: 750px;
  }
  @media (min-width: 768px) {
    max-height: 530px;
  }
  @media (min-width: 992px) {
    max-height: 480px;
    padding: 40px 0px;
  }
  @media (min-width: 1200px) {
    padding: 50px 0;
    max-height: 500px;
  }
  @media (min-width: 1400px) {
    padding: 60px 0;
    max-height: 440px;
  }
`;

export const FooterText = styled.p`
  font-size: 15px;
  color: ${(props) => (props.isFromInterview ? 'var(--secondaryWhite)' : 'var(--darkGreyTxtColor)')};
  padding-bottom: 3px;
`;

export const SocialLinks = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 5px;
`;

export const SocialMedia = styled.a`
  color: ${(props) => (props.isFromInterview ? '#d1d1d1' : 'var(--darkGreyTxtColor)')} !important;
  font-size: 18px;
  padding: 5px;
  :hover {
    color: ${(props) => (props.isFromInterview ? 'var(--siteBgColor)' : 'var(--inputTxtColor)')} !important;
  }
  @media (min-width: 768px) {
    font-size: 20px;
  }
`;

export const FooterContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FooterTitle = styled.h4`
  color: ${(props) => (props.isFromInterview ? 'var(--siteBgColor)' : 'var(--normalTxtColor)')};
`;

export const PagesLink = styled.a`
  display: inline-block;
  color: ${(props) => (props.isFromInterview ? '#d1d1d1' : '#6d6d6d')} !important;
  padding: 3px 0px;
  font-size: 14px;
  text-underline-offset: 3px;
  :hover {
    color: ${(props) => (props.isFromInterview ? 'var(--siteBgColor)' : 'var(--inputTxtColor)')} !important;
    text-decoration: underline !important;
  }
`;
